import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 站点列表
export const getAdmins = (params) => { return req("get", "/admin/admins?"+getHttpParams(params)) };

//新增
export const addAdmins = (params) => { return req("get", "/admin/admins/create?"+getHttpParams(params)) };


export const updateAdmins = (id, params) => { return req("patch", "/admin/admins/"+id+'?'+getHttpParams(params)) };


export const deleteAdmins = (id) => { return req("delete", "/admin/admins/"+id) };


export const resetPass = (id, params) => { return req("get", "/admin/resetPass/"+id+'?'+getHttpParams(params)) };


// 获取用户菜单
export const menu = (params,id) => { return axios.get("/admin/showLeftMenu?role_id="+id +"&token=" + localStorage.getItem('logintoken')).then(res => res.data) };





// WEBPACK FOOTER //
// ./src/api/adminuser.js